export const sequence = async promises => {
  return promises.reduce(async (results, promise) => {
    return [...(await results), await promise()];
  }, Promise.resolve([]));
};
//# sourceMappingURL=sequence.js.map